import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PdmEntity } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class PdmDataService extends CrudService<PdmEntity> {

  protected url: string;

  constructor(
    @Inject(OPERACAO_API_URL) urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.url = `${urlBase}/v1/pdm`;
  }
 
}
